/** Optional purposes the user consents to separately (gyming-back privacy-consent.types). */
export type ConsentPurpose = 'metaAdMeasurement' | 'sessionReplay';
export const CONSENT_PURPOSES: readonly ConsentPurpose[] = ['metaAdMeasurement', 'sessionReplay'];

/** Where the choice was made: onboarding sheet, existing-user prompt or Settings. */
export type ConsentSource = 'onboarding' | 'prompt' | 'settings';

export interface PurposeConsent {
  granted: boolean;
  /** Server time of the last explicit choice; null when the user never chose. */
  updatedAt: string | null;
  policyVersion: string | null;
  source: ConsentSource | null;
}

/** `privacyConsents` of GET /api/user and the PUT /api/user/privacy-consents response. */
export interface PrivacyConsents {
  metaAdMeasurement: PurposeConsent;
  sessionReplay: PurposeConsent;
  promptVersion: number | null;
  promptAnsweredAt: string | null;
}

export type PrivacyConsentChanges = Partial<Record<ConsentPurpose, boolean>>;

export interface UpdatePrivacyConsentsPayload extends PrivacyConsentChanges {
  policyVersion: string;
  source: ConsentSource;
  promptVersion?: number;
}
